import React, { useEffect, useState } from 'react'
import './mentoriaToast.scss'

interface MentoriaToastProps {
    text: string;
    color?: "success" | "error" | "regular";
}

const MentoriaToast = ({ text, color = "regular" }: MentoriaToastProps) => {

    const [show, setShow] = useState(true);
    const TIME_TO_HIDE = 5;

    useEffect(() => {
        if (show) {
            setTimeout(() => {
                setShow(false);

            }, TIME_TO_HIDE * 1000);
        }
    }, [])


    return (
        <div className={`mentoria-toast mentoria-toast--${color} ${show ? 'mentoria-toast--show' : ''}`}>
            <p className={`mentoria-toast__text mentoria-toast__text--${color}`}>{text}</p>
        </div>
    )
}

export default MentoriaToast